/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../../spine/options_pb.js');
var spine_core_command_pb = require('../../../../spine/core/command_pb.js');
var spine_core_event_pb = require('../../../../spine/core/event_pb.js');
goog.exportSymbol('proto.spine.system.server.MarkCausedCommand', null, global);
goog.exportSymbol('proto.spine.system.server.MarkCausedCommands', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.MarkCausedCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.MarkCausedCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.MarkCausedCommand.displayName = 'proto.spine.system.server.MarkCausedCommand';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.MarkCausedCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.MarkCausedCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.MarkCausedCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.MarkCausedCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && spine_core_event_pb.EventId.toObject(includeInstance, f),
    produced: (f = msg.getProduced()) && spine_core_command_pb.CommandId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.MarkCausedCommand}
 */
proto.spine.system.server.MarkCausedCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.MarkCausedCommand;
  return proto.spine.system.server.MarkCausedCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.MarkCausedCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.MarkCausedCommand}
 */
proto.spine.system.server.MarkCausedCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_core_event_pb.EventId;
      reader.readMessage(value,spine_core_event_pb.EventId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new spine_core_command_pb.CommandId;
      reader.readMessage(value,spine_core_command_pb.CommandId.deserializeBinaryFromReader);
      msg.setProduced(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.MarkCausedCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.MarkCausedCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.MarkCausedCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.MarkCausedCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_core_event_pb.EventId.serializeBinaryToWriter
    );
  }
  f = message.getProduced();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_command_pb.CommandId.serializeBinaryToWriter
    );
  }
};


/**
 * optional spine.core.EventId id = 1;
 * @return {?proto.spine.core.EventId}
 */
proto.spine.system.server.MarkCausedCommand.prototype.getId = function() {
  return /** @type{?proto.spine.core.EventId} */ (
    jspb.Message.getWrapperField(this, spine_core_event_pb.EventId, 1));
};


/** @param {?proto.spine.core.EventId|undefined} value */
proto.spine.system.server.MarkCausedCommand.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.MarkCausedCommand.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.MarkCausedCommand.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.CommandId produced = 2;
 * @return {?proto.spine.core.CommandId}
 */
proto.spine.system.server.MarkCausedCommand.prototype.getProduced = function() {
  return /** @type{?proto.spine.core.CommandId} */ (
    jspb.Message.getWrapperField(this, spine_core_command_pb.CommandId, 2));
};


/** @param {?proto.spine.core.CommandId|undefined} value */
proto.spine.system.server.MarkCausedCommand.prototype.setProduced = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.MarkCausedCommand.prototype.clearProduced = function() {
  this.setProduced(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.MarkCausedCommand.prototype.hasProduced = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.MarkCausedCommands = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.system.server.MarkCausedCommands.repeatedFields_, null);
};
goog.inherits(proto.spine.system.server.MarkCausedCommands, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.MarkCausedCommands.displayName = 'proto.spine.system.server.MarkCausedCommands';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.system.server.MarkCausedCommands.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.MarkCausedCommands.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.MarkCausedCommands.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.MarkCausedCommands} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.MarkCausedCommands.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && spine_core_event_pb.EventId.toObject(includeInstance, f),
    producedList: jspb.Message.toObjectList(msg.getProducedList(),
    spine_core_command_pb.CommandId.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.MarkCausedCommands}
 */
proto.spine.system.server.MarkCausedCommands.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.MarkCausedCommands;
  return proto.spine.system.server.MarkCausedCommands.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.MarkCausedCommands} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.MarkCausedCommands}
 */
proto.spine.system.server.MarkCausedCommands.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_core_event_pb.EventId;
      reader.readMessage(value,spine_core_event_pb.EventId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new spine_core_command_pb.CommandId;
      reader.readMessage(value,spine_core_command_pb.CommandId.deserializeBinaryFromReader);
      msg.addProduced(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.MarkCausedCommands.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.MarkCausedCommands.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.MarkCausedCommands} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.MarkCausedCommands.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_core_event_pb.EventId.serializeBinaryToWriter
    );
  }
  f = message.getProducedList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      spine_core_command_pb.CommandId.serializeBinaryToWriter
    );
  }
};


/**
 * optional spine.core.EventId id = 1;
 * @return {?proto.spine.core.EventId}
 */
proto.spine.system.server.MarkCausedCommands.prototype.getId = function() {
  return /** @type{?proto.spine.core.EventId} */ (
    jspb.Message.getWrapperField(this, spine_core_event_pb.EventId, 1));
};


/** @param {?proto.spine.core.EventId|undefined} value */
proto.spine.system.server.MarkCausedCommands.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.MarkCausedCommands.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.MarkCausedCommands.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated spine.core.CommandId produced = 2;
 * @return {!Array<!proto.spine.core.CommandId>}
 */
proto.spine.system.server.MarkCausedCommands.prototype.getProducedList = function() {
  return /** @type{!Array<!proto.spine.core.CommandId>} */ (
    jspb.Message.getRepeatedWrapperField(this, spine_core_command_pb.CommandId, 2));
};


/** @param {!Array<!proto.spine.core.CommandId>} value */
proto.spine.system.server.MarkCausedCommands.prototype.setProducedList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.spine.core.CommandId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.core.CommandId}
 */
proto.spine.system.server.MarkCausedCommands.prototype.addProduced = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.spine.core.CommandId, opt_index);
};


proto.spine.system.server.MarkCausedCommands.prototype.clearProducedList = function() {
  this.setProducedList([]);
};


goog.object.extend(exports, proto.spine.system.server);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../../known_type_parsers.js');

proto.spine.system.server.MarkCausedCommand.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.MarkCausedCommand.fromObject(jsObject);
};

proto.spine.system.server.MarkCausedCommand.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.MarkCausedCommand();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.core.EventId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.produced !== undefined) {
    if (obj.produced === null) {
      msg.setProduced(null);
    } else {
      let value = proto.spine.core.CommandId.fromObject(obj.produced);
      msg.setProduced(value);
    }
  }
  return msg;
};

proto.spine.system.server.MarkCausedCommands.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.MarkCausedCommands.fromObject(jsObject);
};

proto.spine.system.server.MarkCausedCommands.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.MarkCausedCommands();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.core.EventId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.produced !== undefined && obj.produced !== null) {
    obj.produced.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addProduced(null);
        } else {
          let value = proto.spine.core.CommandId.fromObject(listItem);
          msg.addProduced(value);
        }
      }
    );
  }
  return msg;
};
